import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './types'
import orderApi from '@/api/index/orderApi'
import RefundAPI from '@/api/index/refundApi'
import Utils from '@/utils/Util'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    orderList: {},
    // orderInfo: {},
    comps: {},
    loading: false,
    reloading: false,
    logisList: [],
    refundList: [],
    currency: '$',
    coinObj: {}
  },
  mutations: {
    [types.ORDERLIST](state, { rec }) {
      Array.isArray(rec.records) && rec.records.forEach(v => {
        v.isLogistShow = false
        v.logisticsData = {
          visible: false
        }
        if(v.itemList && Array.isArray(v.itemList)) {
          v.itemList.forEach((product) => {
            product.customFieldCount = 0
            if (product.customField) {
              try {
                product.customField = JSON.parse(product.customField)
                if (product.customField && Array.isArray(product.customField)) {
                  product.customField.forEach((subItem) => {
                    if (subItem.val && Array.isArray(subItem.val)) {
                      product.customFieldCount += subItem.val.length
                    } else {
                      subItem.val = JSON.parse(subItem.val)
                      if (subItem.val && Array.isArray(subItem.val)) {
                        product.customFieldCount += subItem.val.length
                      }
                    }
                  })
                }
              } catch (error) {
                product.customField = []
              }
            }
          })
        }
      })
      state.orderList = rec
    },
    [types.REFUNDLIST](state, { rec }) {
      Array.isArray(rec.records) && rec.records.forEach(v => {
        v.isLogistShow = false
        v.logisticsData = {
          visible: false
        }

        if(v.itemVOList && Array.isArray(v.itemVOList)) {
          v.itemVOList.forEach((product) => {
            product.customFieldCount = 0
            if (product.customField) {
              try {
                product.customField = JSON.parse(product.customField)
                if (product.customField && Array.isArray(product.customField)) {
                  product.customField.forEach((subItem) => {
                    if (subItem.val && Array.isArray(subItem.val)) {
                      product.customFieldCount += subItem.val.length
                    } else {
                      subItem.val = JSON.parse(subItem.val)
                      if (subItem.val && Array.isArray(subItem.val)) {
                        product.customFieldCount += subItem.val.length
                      }
                    }
                  })
                }
              } catch (error) {
                product.customField = []
              }
            }
          })
        }
      })
      state.refundList = rec
    },
    [types.ORDERCOMP](state, { rec }) {
      state.comps = rec
    },
    [types.ORDERWAYBILL](state, { rec }) {
      state.logisList = rec
    },
    [types.PROD_LOAD](state, { loading }) {
      state.loading = loading
    },
    [types.REFUND_LOAD](state, { loading }) {
      state.reloading = loading
    },
    [types.CURRENCY_OBJ](state, { obj }) {
      state.currency = obj[Utils.getCookie('currency') || 'USD']
    },
    [types.COIN_OBJ](state, { obj }) {
      state.coinObj = obj
    },
  },
  actions: {
    getOrderList({ commit }, params) {
      commit(types.PROD_LOAD, { loading: true })
      orderApi.getList(params).then(res => {
        let rec = res.data.data
        commit(types.ORDERLIST, { rec })
        commit(types.PROD_LOAD, { loading: false })
      })
    },
    getRefundList({ commit }, params) {
      commit(types.REFUND_LOAD, { reloading: true })
      RefundAPI.getRefundList(params).then(res => {
        let rec = res.data.data
        commit(types.REFUNDLIST, { rec })
        commit(types.REFUND_LOAD, { reloading: false })
      })
    },
    getComp({ commit }) {
      orderApi.getCompanys({ 'dictCode': 'LOGISTICS_TYPE' }).then(res => {
        let rec = res.data.data
        rec.push({ dictdataName: '其他', id: 0 })
        commit(types.ORDERCOMP, { rec })
      })
    },
    getLogistList({ commit }, expressNo) {
      orderApi.getLogistList({ expressNo: expressNo }).then(res => {
        let rec = res.data.data
        commit(types.ORDERWAYBILL, { rec })
      })
    },
    getCurrencyList({ commit }) {
      orderApi.currencyList().then(res => {
        if (!res.data.code) {
          const list = res.data.data
          const obj = list.reduce((obj, v) => {
            obj[v.currencyCode] = v.currencyUnit
            return obj
          }, {})
          commit(types.COIN_OBJ, { obj })
          commit(types.CURRENCY_OBJ, { obj })
        }
      })
    },
  },
  getters: {
    orderList: state => state.orderList,
    comps: state => state.comps,
    loading: state => state.loading,
    logisList: state => state.logisList,
    refundList: state => state.refundList,
    reloading: state => state.reloading,
    currency: state => state.currency
  }
})
export default store
